// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"globalFooter___XqKrY","links":"links___Alib7","copyright":"copyright___2UhzN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ant-design-pro/GlobalFooter/index.less
// module id = KWdA
// module chunks = 2